import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckIndeterminateSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1280 576V704Q1280 730 1261.0 749.0Q1242 768 1216 768H320Q294 768 275.0 749.0Q256 730 256 704V576Q256 550 275.0 531.0Q294 512 320 512H1216Q1242 512 1261.0 531.0Q1280 550 1280 576ZM1536 1120V160Q1536 41 1451.5 -43.5Q1367 -128 1248 -128H288Q169 -128 84.5 -43.5Q0 41 0 160V1120Q0 1239 84.5 1323.5Q169 1408 288 1408H1248Q1367 1408 1451.5 1323.5Q1536 1239 1536 1120Z"
	})
});
export default SvgCheckIndeterminateSmall;
